// Pembulatan angka
export const formatRounding = (value, factor = 100) => {
  return Math.floor(value * factor) / factor;
};

// Formatter tanggal YYYY-MM-DD
const formatDate = (date) => {
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${yyyy}-${mm}-${dd}`;
};

// Hari ini
const currentDate = new Date();
export const today = formatDate(currentDate);

const tomorrowDate = new Date(currentDate);
tomorrowDate.setDate(currentDate.getDate() + 1);
export const tomorrow = formatDate(tomorrowDate);

// Kemarin
const yesterdayDate = new Date(currentDate);
yesterdayDate.setDate(currentDate.getDate() - 1);
export const yesterday = formatDate(yesterdayDate);

// 7 hari yang lalu
const lastWeekDate = new Date(currentDate);
lastWeekDate.setDate(currentDate.getDate() - 7);
export const lastWeek = formatDate(lastWeekDate);

// 30 hari yang lalu
const lastMonthDate = new Date(currentDate);
lastMonthDate.setMonth(currentDate.getMonth() - 1);
export const lastMonth = formatDate(lastMonthDate);

// format untuk response data unit options
export const formatUnitOptions = (res) => {
  return (
    res?.map((item) => ({
      value: item.unit_id,
      label: item.name,
    })) || []
  );
};

export const formatDestinationOptions = (res) => {
  return (
    res?.map((item) => ({
      value: item.destination_po_id,
      label: item.name,
    })) || []
  );
};

export const formatSupplierOptions = (res) => {
  return (
    res?.map((item) => ({
      value: item.supplier_id,
      label: item.name,
    })) || []
  );
};

export const formatPurchaseOptions = (res) => {
  return (
    res?.map((item) => ({
      ...item,
      value: item.purchase_list_id,
      label: `${item.purchase_no} - ${item.supplier_name} - ${item.outlet_name} - ${item.purchase_date}`,
    })) || []
  );
};

const firstDayOfMonth = new Date(
  currentDate.getFullYear(),
  currentDate.getMonth(),
  1,
);

export const startOfMonth = formatDate(firstDayOfMonth);

const lastDayOfMonth = new Date(
  currentDate.getFullYear(),
  currentDate.getMonth() + 1,
  0,
);
export const endOfMonth = formatDate(lastDayOfMonth);

export const threeMonthsAgoDate = new Date(currentDate);
threeMonthsAgoDate.setMonth(currentDate.getMonth() - 3);
export const threeMonthsAgo = formatDate(threeMonthsAgoDate);

const sixMonthsAgoDate = new Date(currentDate);
sixMonthsAgoDate.setMonth(currentDate.getMonth() - 6);
export const sixMonthsAgo = formatDate(sixMonthsAgoDate);

export const formatIDR = (
  value,
  {
    prefix = "Rp", // "Rp" / "" / "IDR" / "Rp." / custom
    decimal = false, // true = pakai decimal, false = tanpa decimal
    decimalDigits = 2, // jumlah decimal jika decimal = true
  } = {},
) => {
  if (value === null || value === undefined || value === "") return "";

  const num = Number(value);

  const formatted = num.toLocaleString("id-ID", {
    minimumFractionDigits: decimal ? decimalDigits : 0,
    maximumFractionDigits: decimal ? decimalDigits : 0,
  });

  return prefix ? `${prefix} ${formatted}` : formatted;
};
